import { useCallback, useMemo } from 'react';

import { useCss } from 'craft/hooks';
import { CssSelectorId } from 'craft/types';

export const useShadowCss = (
  nodeIds: string[],
  cssSelectorId?: CssSelectorId,
  isFilter?: boolean,
) => {
  const { css, setCss, stylesHierarchy } = useCss(nodeIds, { cssSelectorId });

  const cssKey = isFilter ? 'filter' : 'boxShadow';
  const styleHierarchy = stylesHierarchy?.[cssKey];
  const defaultStyleguideValue = styleHierarchy?.fallbackValue;
  const hasShadowInStyleguide = typeof defaultStyleguideValue !== 'undefined';

  const hasShadow = useMemo(() => {
    return css[cssKey] !== 'initial' && (!!css.boxShadow || !!css.filter?.includes('drop-shadow'));
  }, [css]);

  const toggleShadow = useCallback(() => {
    let newValue;
    let resetValue;
    if (hasShadowInStyleguide) {
      resetValue = 'initial';
    }

    if (isFilter) {
      newValue = {
        boxShadow: undefined,
        filter: hasShadow
          ? resetValue
          : defaultStyleguideValue || 'drop-shadow(0px 0px 0px #D2D6DB)',
      };
    } else {
      newValue = {
        boxShadow: hasShadow ? resetValue : defaultStyleguideValue || '0px 0px 0px 0px #D2D6DB',
        filter: undefined,
      };
    }

    setCss(newValue);
  }, [css, setCss, hasShadow]);

  return { css, setCss, cssKey, hasShadow, toggleShadow, styleHierarchy, hasShadowInStyleguide };
};
